<!--
 * @Descripttion: Cancellation Policy 独立取消政策页面
-->

<template>
  <div class="cancellation-policy">
    <!-- Page Header -->
    <div class="policy-header">
      <div class="policy-header-bg"></div>
      <div class="policy-header-content">
        <h1>Cancellation Policy</h1>
        <p>Clear, fair and simple</p>
      </div>
    </div>

    <!-- Policy Body -->
    <div class="policy-layout">
      <div class="policy-content">
        <MyMarkdown :nid="5"></MyMarkdown>
      </div>
    </div>
  </div>
</template>

<script>
import MyMarkdown from '../components/MyMarkdown'

export default {
  name: 'CancellationPolicy',
  components: {
    MyMarkdown
  }
}
</script>

<style scoped>
.cancellation-policy {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.policy-header {
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.policy-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}
.policy-header-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.policy-header-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 20px;
}
.policy-header-content h1 {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.policy-header-content p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  font-style: italic;
}

.policy-layout {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 24px 80px;
}
.policy-content {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.06);
}

@media (max-width: 900px) {
  .policy-header {
    height: 200px;
  }
  .policy-header-content h1 {
    font-size: 26px;
    letter-spacing: 1px;
  }
  .policy-header-content p {
    font-size: 14px;
  }
  .policy-layout {
    padding: 20px 12px 60px;
  }
  .policy-content {
    padding: 24px;
    border-radius: 12px;
  }
}
</style>
